import { render, staticRenderFns } from "./TabChecklistGenerale.vue?vue&type=template&id=28b8f3d6&"
import script from "./TabChecklistGenerale.vue?vue&type=script&lang=js&"
export * from "./TabChecklistGenerale.vue?vue&type=script&lang=js&"
import style0 from "./TabChecklistGenerale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports